import { createAsyncThunk } from '@reduxjs/toolkit';
import { AllocationService } from '../Apis/AllocationService';
import { CreateRuleFormData } from '../components/Allocation/CreateRuleDrawer';
import { ReallocateAllocationFormData } from '../components/Allocation/ReallocateAllocationsDrawer';

import { AllocationStatusViewModel } from '../types/allocations';
import {
  BulkAllocateRequest,
  DownloadBulkAllocateFileRequest,
  ExecuteCriteriaRequest,
  GetAllocationMetaDataRequest,
  GetAllocationsListRequest,
  GetAutoAllocationCriteriaListRequest,
} from '../types/request/allocation';
import { getErrorMessageFromErrorObj } from '../utils/api';

// export class AllocationActions {

// }

export const fetchAllocations = createAsyncThunk(
  'allocations/fetch',
  async (request: Partial<GetAllocationsListRequest>) => {
    const response = await AllocationService.getAllocations(request);
    return response;
  }
);
export const fetchAllocationsMetaData = createAsyncThunk(
  'allocations/fetchAllocationsMetaData',
  async (request: Partial<GetAllocationMetaDataRequest>) => {
    const response = await AllocationService.getAllocationMetaData(request);
    return response;
  }
);

export const reallocateAllocations = createAsyncThunk(
  'allocations/reallocate',
  async (request: {
    loanIds: string[];
    formData: Partial<ReallocateAllocationFormData>;
  }) => {
    const response = await AllocationService.reallocate({
      loanIds: request.loanIds,
      agentId: request.formData.agentId,
      expiresAt: request.formData.expiryDate,
      allocationType: request.formData.allocationType,
    });
    return response;
  }
);

export const fetchAllocationStatus = createAsyncThunk(
  'allocations/statusCount',
  async () => {
    const response: AllocationStatusViewModel = {
      UNALLOCATED: 10,
      ALLOCATED: 220,
      NORMALIZED: 0,
      STABILIZED: 0,
      ROLLBACK: 0,
      CANCELLED: 0,
    };
    return response;
  }
);

export const fetchAllocationRules = createAsyncThunk(
  'allocations/fetchRules',
  async (request: Partial<GetAutoAllocationCriteriaListRequest>) => {
    const response = await AllocationService.getAutoAllocationCriteria(request);
    return response;
  }
);

export const executeCriteria = createAsyncThunk(
  'allocations/executeCriteria',
  async (request: Partial<ExecuteCriteriaRequest>) => {
    const response = await AllocationService.executeCriteria(request);
    return response;
  }
);

export const fetchCriteriaAttributes = createAsyncThunk(
  'allocations/fetchAttributes',
  async (_, { rejectWithValue }) => {
    try {
      return await AllocationService.getAutoAllocationAttributes();
    } catch (error) {
      return rejectWithValue(getErrorMessageFromErrorObj(error));
    }
  }
);

export const createRule = createAsyncThunk(
  'allocations/createRule',
  async (
    request: Partial<CreateRuleFormData>,
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response = await AllocationService.createRule({
        criteriaList: request.criterias,
        name: request.name,
        agentId: request.agentId,
        expiresAt: request.expiry,
      });
      dispatch(fetchAllocationRules({ page: 0 }));
      return response;
    } catch (error) {
      return rejectWithValue(getErrorMessageFromErrorObj(error));
    }
  }
);

export const fetchBulkAllocations = createAsyncThunk(
  'allocations/bulkAllocations',
  async (_, { rejectWithValue }) => {
    try {
      const response = await AllocationService.getBulkAllocationListMeta();
      return response;
    } catch (error) {
      return rejectWithValue(getErrorMessageFromErrorObj(error));
    }
  }
);

export const bulkAllocate = createAsyncThunk(
  'allocations/bulkAllocate',
  async (request: Partial<BulkAllocateRequest>, { rejectWithValue }) => {
    try {
      const response = await AllocationService.bulkAllocate(request);
      return response;
    } catch (error) {
      return rejectWithValue(getErrorMessageFromErrorObj(error));
    }
  }
);

// export const downloadBulkDeallocationSampleFile = createAsyncThunk(
//   'allocations/downloadBulkDeallocationSample',
//   async () => {
//     const response =
//       await AllocationService.downloadBulkDeallocationSampleFile();
//     return response;
//   }
// );

export const fetchBulkDeAllocations = createAsyncThunk(
  'allocations/bulkDeAllocations',
  async (_, { rejectWithValue }) => {
    try {
      const response = await AllocationService.getBulkDeAllocationListMeta();
      return response;
    } catch (error) {
      return rejectWithValue(getErrorMessageFromErrorObj(error));
    }
  }
);

export const bulkDeAllocate = createAsyncThunk(
  'allocations/bulkDeAllocate',
  async (request: Partial<BulkAllocateRequest>, { rejectWithValue }) => {
    try {
      const response = await AllocationService.bulkDeAllocate(request);
      return response;
    } catch (error) {
      return rejectWithValue(getErrorMessageFromErrorObj(error));
    }
  }
);
export const downloadBulkErrorFile = createAsyncThunk(
  'allocations/downloadBulkErrorFile',
  async (request: Partial<DownloadBulkAllocateFileRequest>) => {
    const response = await AllocationService.downloadBulkErrorFile(request);
    return response;
  }
);
